import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Col, Modal, Row } from "antd";
import { FcInfo } from "react-icons/fc";
import { COLORS } from "../../../config/theme";

const BetaModal = ({ betaModal, setBetaModal }) => {
  const history = useHistory();

  const { primary } = COLORS;
  return (
    <Modal
      visible={betaModal}
      footer={null}
      closable={false}
      centered
      width="50rem"
      bodyStyle={{
        padding: "3rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div>
        <Col>
          <FcInfo
            style={{
              height: "5rem",
              width: "100%",
              alignSelf: "center",
              marginBottom: "2rem",
            }}
          />
          <Row>
            <span
              style={{
                fontSize: "1.1rem",
                fontWeight: "500",
                marginBottom: "1.3rem",
                textAlign: "justify",
              }}
            >
              All premium plans are available in BETA testing mode and free to
              use for limited time. After we finish the testing mode, the free
              use of the premium plans will be cancelled and the portal admin
              must buy a subscription to use the premium plans again. By
              clicking on I agree, you accept the terms mentioned above and want
              to activate the plan.
            </span>
          </Row>
          <Row
            style={{
              width: "100%",
              alignContent: "space-evenly",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              shape="round"
              type="primary"
              style={{
                background: primary,
                borderColor: primary,
                width: "6rem",
              }}
              onClick={() => {
                history.push("/app/wave-cards");
              }}
            >
              Cancel
            </Button>
            <Button
              shape="round"
              type="primary"
              style={{
                background: primary,
                borderColor: primary,
                width: "6rem",
              }}
              onClick={() => {
                setBetaModal(false);
              }}
            >
              Agree
            </Button>
          </Row>
        </Col>
      </div>
    </Modal>
  );
};

export default BetaModal;
